
import { classifiersStore } from '@/store'
import { ValidationObserver } from 'vee-validate'
import { Component, Prop } from 'vue-property-decorator'
import { ApplicationUtils } from '@/commons/utils/application'
import {
    ApplicationDocument,
    Classifier,
    ValidationError
} from '@/commons/types'
import { translateValidationError } from '@/commons/configuration/vee.validate'
import RadioButtonRounded from '@/commons/components/core/RadioButtonRounded.vue'
import ModalBoxIsLostStolenDestroyed from '@/commons/components/modal-box/ModalBoxIsLostStolenDestroyed.vue'
import {
    CitizenPassportValidationFieldName,
    validatorIds
} from '@/commons/constants/application'
import TextareaWithLabel from '@/commons/components/core/TextareaWithLabel.vue'
import {
    ApplicationReason,
    ExcludedApplicationReason
} from '@/commons/constants/classifier'
import $ from 'jquery'

@Component({
    components: {
        ModalBoxIsLostStolenDestroyed,
        RadioButtonRounded,
        TextareaWithLabel
    }
})
export default class ApplicationReasons extends ValidationObserver {
    @Prop() ruleId!: string
    @Prop() documentType!: string
    @Prop() subtitleKey: string | undefined
    @Prop() excludedClassifiers: Array<string> | undefined
    @Prop({ default: 'application-reason' }) buttonGroup!: string
    domValidatorIds = validatorIds
    reasonExplanationId = CitizenPassportValidationFieldName.REASON_EXPLANATION

    get applicationReasons (): Array<Classifier> {
        return classifiersStore.applicationReasons
    }

    get filteredApplicationReasons (): Array<Classifier> {
        return this.applicationReasons.filter((classifier: Classifier) => {
            if (!this.excludedClassifiers || this.excludedClassifiers.length < 1) {
                return true
            }
            return this.excludedClassifiers.indexOf(classifier.code) < 0
        }).sort((cl1, cl2) => {
            if (cl1.code === ApplicationReason.OTHER_REASON.toString()) {
                return 1
            }
            if (cl2.code === ApplicationReason.OTHER_REASON.toString()) {
                return -1
            }
            if (cl1.code === ApplicationReason.LOST_STOLEN_DESTROYED.toString()) {
                return 1
            }
            if (cl2.code === ApplicationReason.LOST_STOLEN_DESTROYED.toString()) {
                return -1
            }
            return 0
        })
    }

    translateError (validationError: ValidationError): string {
        return translateValidationError(validationError)
    }

    get applicationDocument (): ApplicationDocument {
        return ApplicationUtils.getDocument(this.documentType)
    }

    get reason (): string | null {
        return this.applicationDocument.reason
    }

    setReason (reason: string | null): void {
        this.applicationDocument.reason = reason
        if (reason === ApplicationReason.LOST_STOLEN_DESTROYED) {
            this.setIsLost()
        }
        if (!this.isAdditionalPassport) {
            this.setReasonExplanation(null)
        }
    }

    setIsLost (): void {
        this.showLostModal()
    }

    showLostModal (): void {
        $('#isLostStolenDestroyedModal-' + this.documentType).modal('show')
    }

    get reasonExplanation (): string | null {
        return this.applicationDocument.reasonExplanation
    }

    setReasonExplanation (reasonExplanation: string | null): void {
        this.applicationDocument.reasonExplanation = reasonExplanation
    }

    get isAdditionalPassport (): boolean {
        return this.reason === ExcludedApplicationReason.ADDITIONAL_PASSPORT
    }
}

